import type { ReactNode } from 'react';
import RuleItem from './RuleItem';

type Rule = {
	icon: ReactNode;
	title: string;
	value: string;
	onClick?: () => void;
};

type Props = {
	rules: Rule[];
};

const Rules = (props: Props) => {
	const { rules } = props;
	return (
		<div className="bg-surfaceContainerLow rounded-[28px]">
			{rules.map((rule) => (
				<RuleItem
					key={rule.value}
					icon={rule.icon}
					title={rule.title}
					value={rule.value}
					onClick={rule.onClick}
				/>
			))}
		</div>
	);
};

export default Rules;
